import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-loading" }
const _hoisted_2 = { class: "icon animate spin" }

import { svgIcon } from "@/common/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'full-loading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(svgIcon), {
        icon: "loading",
        size: "3rem"
      })
    ])
  ]))
}
}

})